<ng-template #instructionsTemplate><ng-content select="[projectedInstructions]"></ng-content></ng-template>
<ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
<!--
--------------------------------------------------------------------------------------------------
SEE https://community-dc.max.gov/x/qgY0mQ FOR AN OVERVIEW OF HOW ATTACHMENTS HAVE BEEN IMPLEMENTED
--------------------------------------------------------------------------------------------------
-->
<ng-template #additionalInfoDiv>
  <div style="color:black;font-weight: bold;margin:15px;">Note: Any columns you add here will display to the left of standard Attachment columns (Title, File Name etc.)</div>
</ng-template>

@if (IsInDesignMode) {
  <div class="grid-design-div" data-grid-type="attachment-grid">
    <div class="{{this.Mode =='design' ? 'design-mode-field-label' : 'field-label'}}">@if (this.ShowLabel) {
      <mat-label>{{this.DisplayName}} @if (this.FormField.required) {
        <span style="color: #EF0000;">*</span>
      }</mat-label>
    }</div>
    <!--
    A note about event handling. I tried to handle (designChange) on app-grid-field-designer below BUT GridFieldDesignerComponent actually fires
    that event through its GridFormFieldComponent like this...
    this.gridFormFieldComponent.designChange.emit(true);
    ...SO, instead the event has to be handled in the TS file by subscribing to wrappedGridFormFieldComponent.designChange
    -->
    <app-grid-field-designer [gridFormFieldComponent]="WrappedGridFormFieldComponent">
      <!-- Project attachment-specific content into GridFieldDesigner -->
      <ng-container projectedAdditionalInfo *ngTemplateOutlet="additionalInfoDiv"></ng-container>
    </app-grid-field-designer>
    <!-- Define a design mode context menu. -->
    <mat-menu #gridCellContextMenu="matMenu">
      <ng-template matMenuContent let-row="row">
        <button mat-menu-item
          [disabled]="false"
          (click)="this.gridCellContextMenuItemClicked($event,'Properties ...')">
          Properties ...
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item
          [disabled]="false"
          (click)="this.gridCellContextMenuItemClicked($event,'Delete')">
          Delete
        </button>
      </ng-template>
    </mat-menu>
    <!-- Define a menu trigger. -->
    <div style="visibility: hidden; position: fixed"
      [style.left]="this.ContextMenuPositionX"
      [style.top]="this.ContextMenuPositionY"
      [matMenuTriggerFor]="gridCellContextMenu">
    </div>
    <!---END DESIGN MODE CONTEXT MENU-->
  </div>
}

@if (IsInPreviewOrInstanceMode) {
  <div class="preview-and-instance-modes-div" data-grid-type="attachment-grid">
      @if (this.DisplayName) {
      <div class="field-label">{{this.DisplayName}}</div>
      }
      <button [disabled]="FormField.readOnly" mat-stroked-button style="margin:10px;" (click)="openUploadDialog(FormInstanceElement.id)">Upload</button>
      <button mat-stroked-button style="margin:10px;" (click)="toggleShowAll()">{{ToggleShowAllButtonText}}</button>
      <app-grid-field-editor #gridFieldEditor
                             [flavor]="AttachmentsGridFlavor"
                             [formInstance]="FormInstance"
                             [gridFormFieldComponent]="WrappedGridFormFieldComponent"
                             [isFootnotesGrid]="false"
                             (editorInitialized)="WrappedGridFormFieldComponent.setGridFieldEditorComponent($event)"
                             (editorGridValidation)="this.handleEditorGridValidation($event)"
                             (conditionalLogicColumnDefsFilter)="this.handleConditionalLogicColumnDefsFilter($event)"
                             (gridEvent)="this.handleGridEvent($event)">
      </app-grid-field-editor>
      <!-- hide the file uploader that's used under the hood -->
      <div style="display: none">
          <app-file-uploader [dataCollectionId]="this.DataCollectionId"
                             [folderId]="this.FolderId"
                             [formInstanceId]="this.FormInstanceId"
                             [formFieldId]="this.FormField.id"
                             (filesUploaded)="this.handleFilesUploaded($event)">
          </app-file-uploader>
      </div>
  </div>
}
